import Expandable from './Expandable'

export default Expandable
